<script setup lang="ts">
  import { ref } from 'vue'
  import { useAppModal } from '@//components/modal'
  import { useApi } from '@/functions/api'

  const api = useApi()

  const password = ref('')
  let actionConfirmed: () => void
  const { modal, open, close } = useAppModal((onConfirmed: () => void) => {
    password.value = ''
    actionConfirmed = onConfirmed
  })
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submit = async () => {
    submitting.value = true
    try {
      await api.POST('password/confirm-action', { password: password.value })
      actionConfirmed()
      close()
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  defineExpose({ open, close })
</script>

<template>
  <app-modal
    ref="modal"
    title="Masukkan Password Untuk Konfirmasi">
    <app-modal-form @submit="submit">
      <app-input-password
        v-model="password"
        v-focus
        label="Password"
        :error="errors.password"
        required />
      <div class="mt-4 text-center">
        <app-submit
          class="btn-primary w-32"
          :loading="submitting">
          Submit
        </app-submit>
      </div>
    </app-modal-form>
  </app-modal>
</template>
